var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "icon-404" }, [_vm._v("404")]),
      _c("div", [_vm._v("Not Found")]),
      _c("div")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }